// extracted by mini-css-extract-plugin
export default {"otp_box":"OtpInput_otp_box__LMPZD","otp_box_input":"OtpInput_otp_box_input__Ux550"};